import swal from 'sweetalert2';
import store from '../store';


const formatDate = (isoString) => {
  if(!isoString)
    return '';
  const date = new Date(isoString);
  // Convert to a readable format 
  let langFormat = 'en-US'
  // if(localStorage.getItem('language') && localStorage.getItem('language') != 'en')
  //   langFormat = 'ar-EG'
  const parts = date.toLocaleString(langFormat, {
    year: 'numeric',
    // month: 'long',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true, 
  });

  const [mdy, time] = parts.split(', ');
  const [month, day, year] = mdy.split('/');
  const formatted = `${year}-${month}-${day} ${time}`;
  return formatted;
}


const shortDate = (date) => {
  if(!date)
    return '';
  return new Date(date).toISOString().split("T")[0];
}


const toast = (msg, icon='error') => {
  const Toast = swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = swal.stopTimer;
      toast.onmouseleave = swal.resumeTimer;
    }
  });
  Toast.fire({
    icon: icon,
    title: msg,
  });
}


const loaderToast = (title, width=70, time=2000) => {
  swal.fire({
    title: title,
    html: `<div class="text-center">
      <img src="/images/subloader.gif" style="width: ${width}px;" alt="">
    </div>`,
    timer: time,
    timerProgressBar: true,
    showConfirmButton: false,
    didOpen: () => {
      // swal.showLoading();
    },
    willClose: () => {
      // clearInterval(timerInterval);
    }
  });
}


const checkAccess = (permissionName) => {
  const user = store.getters.GET_USER_DATA;
  if(!user)
    return false;
  if(user.isSuperUser == true || (user.permissions != undefined && user.permissions.indexOf(permissionName) != -1))
    return true;
  return false;
}

const isImage = (file) => {
  if (!file)
    return false;

  return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
}

//slotted the time to hour and half only for scheduled orders
const timeSlots = () => {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    for (const m of ['00', '30']) {
      const hh = String(h).padStart(2, '0');
      const value = `${hh}:${m}`;
      const period = h < 12 ? 'AM' : 'PM';
      const h12 = h < 12 ? String(h).padStart(2, '0') : (h === 12 ? 12 : h - 12);
      const label = `${h12}:${m} ${period}`;
      slots.push({ value, label });
    }
  }
  return slots;
}


function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

//pricesOffers
const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

const cents = value => Math.round((value + Number.EPSILON) * 100);
const money = value => value / 100;

const calculateOfferTotals = (offer) => {
  const baseValue = offer.manualBasePrice === false && offer.areaSqm !== undefined && offer.pricePerSqm !== undefined
    ? toAmount(offer.areaSqm) * toAmount(offer.pricePerSqm)
    : toAmount(offer.basePrice);
  const baseCents = cents(baseValue);
  const discountCents = cents(toAmount(offer.discountAmount));
  const discountedBaseCents = Math.max(0, baseCents - discountCents);
  const commissionInput = toAmount(offer.commissionRate);
  const commissionCents = offer.commissionMethod === 'fixed'
    ? cents(commissionInput)
    : Math.round(discountedBaseCents * commissionInput / 100);
  const waterCents = cents(toAmount(offer.waterFee));
  const contractCents = cents(toAmount(offer.contractFee));
  const insuranceCents = cents(toAmount(offer.insuranceFee));
  const vatCents = Math.round((discountedBaseCents + commissionCents) * 0.15);
  const totalCents = discountedBaseCents + commissionCents + vatCents + waterCents + contractCents + insuranceCents;

  return {
    basePrice: money(baseCents),
    commissionAmount: money(commissionCents),
    waterFee: money(waterCents),
    contractFee: money(contractCents),
    insuranceFee: money(insuranceCents),
    vatAmount: money(vatCents),
    totalAmount: money(totalCents),
    discountedBasePrice: money(discountedBaseCents),
    discountAmount: money(discountCents),
  };
};

const offerExpiryDate = (date, durationDays) => {
  if (!date || !Number.isInteger(Number(durationDays)) || Number(durationDays) < 1) return '';
  const value = new Date(`${date}T12:00:00`);
  if (Number.isNaN(value.getTime())) return '';
  value.setDate(value.getDate() + Number(durationDays));
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
};

export {
  formatDate, shortDate, toast, loaderToast, checkAccess, isImage, timeSlots, 
  getRandomInt, calculateOfferTotals, offerExpiryDate
}
